// The honest empty state for edge-backed screens (journal, cellar, learn,
// profile) when apps/edge cannot be reached: says what still works, offers
// a retry, and never shows a raw "Failed to fetch".
import { Button, EmptyState, Icon } from "../ui";
import { probeEdge } from "../lib/edgeStatus";
import { useT } from "../lib/i18n";

export function EdgeOffline({ retryTestId }: { retryTestId?: string } = {}): React.JSX.Element {
  const { t } = useT();
  return (
    <EmptyState
      icon="cloud-off"
      title={t("edge.offline.title")}
      body={t("edge.offline.body")}
      role="status"
      action={
        <Button
          tone="secondary"
          icon={<Icon name="refresh" size={18} />}
          // nosemgrep: rules.typescript.react.best-practice.react-props-spreading -- props are typed as the component's own
          {...(retryTestId === undefined ? {} : { "data-testid": retryTestId })}
          onPress={() => void probeEdge(true)}
        >
          {t("common.action.retry")}
        </Button>
      }
    />
  );
}
